export const EASE = [0.2, 0.8, 0.2, 1];

export const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};

export const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: EASE } },
};

export const inView = { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.15 } };

export const numRe = /^\s*\d+\s*[\.\)]\s*/;
